import type { ReactNode } from 'react';

import { FullPageContent } from '@/components/layout/full-page-content';

export type CommunicationShellProps = {
  sidebar: ReactNode;
  children: ReactNode;
};

export function CommunicationShell({
  sidebar,
  children,
}: CommunicationShellProps) {
  return (
    <FullPageContent className="bg-zinc-50" testId="communications-page">
      <div className="flex h-full flex-row">
        <div className="w-[30rem] shrink-0 overflow-hidden border-r">
          {sidebar}
        </div>
        <div className="h-full flex-1 overflow-hidden overflow-y-auto p-6">
          {children}
        </div>
      </div>
    </FullPageContent>
  );
}
